const positions = new Map<string, number>()
const storageKey = (view: string) => `lane-control:chatlist-scroll:${view}`

export function readListPosition(view: string): number {
  if (positions.has(view)) return positions.get(view) ?? 0
  try {
    const top = Number(sessionStorage.getItem(storageKey(view)))
    return Number.isFinite(top) && top > 0 ? top : 0
  } catch { return 0 }
}

export function saveListPosition(view: string, top: number): void {
  positions.set(view, top)
  try { sessionStorage.setItem(storageKey(view), String(top)) }
  catch { /* In-memory positions still survive route changes. */ }
}

/** Wait for asynchronously loaded rows, then stop restoring as soon as the user acts. */
export function bindChatListScroll(list: HTMLElement, top: number, save: (top: number) => void) {
  let restoring = true
  const cancel = () => { restoring = false }
  const restore = () => {
    if (!restoring) return
    list.scrollTop = top
    if (list.scrollHeight - list.clientHeight >= top) restoring = false
  }
  const onScroll = () => { if (!restoring) save(list.scrollTop) }
  const resize = new ResizeObserver(restore)
  const observeRows = () => {
    resize.disconnect()
    for (const child of list.children) resize.observe(child)
    restore()
  }
  const mutations = new MutationObserver(observeRows)
  mutations.observe(list, { childList: true, subtree: true })
  observeRows()
  list.addEventListener('scroll', onScroll, { passive: true })
  const inputs = ['pointerdown', 'touchstart', 'wheel', 'keydown'] as const
  for (const input of inputs) list.addEventListener(input, cancel, { passive: true })
  return {
    cancel,
    dispose() {
      if (!restoring) save(list.scrollTop)
      resize.disconnect()
      mutations.disconnect()
      list.removeEventListener('scroll', onScroll)
      for (const input of inputs) list.removeEventListener(input, cancel)
    },
  }
}
